import React from 'react';
import $ from 'jquery';
import {API_KEY, API_PREFIX} from '../Configuration';
import renderHTML from 'react-render-html';
import '../styles/Post.css';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import {Loading} from "./Loading"
import { Button, Affix } from 'antd';

import QueueAnim from 'rc-queue-anim';

export class Post extends React.Component {
  static contextTypes = {
    router: ()=>true,
  }
  state = {
    data: null
  };

  componentDidMount() {
    const id = this.props.id;
    $.getJSON({
        url: `${API_PREFIX}/get_post_by_id`,
        method: 'GET',
        data: $.param({
          APIKEY: API_KEY,
          id: id,
        })
    }).then((json)=>{
      console.log(json);
      this.setState({data: json});
    }, (err) => {
      console.log('failed');
    });
  }

  render() {
    const p = this.state.data;

    if (!p) {
      return <article><Loading/></article>
    }

    return (
       // <ReactCSSTransitionGroup
       //  transitionName="post"
       //  transitionEnterTimeout={3000}
       // transitionLeaveTimeout={3000}>
        <article>
          <div>
            <QueueAnim delay={300} type={['right', 'left']}>
            { renderHTML(p.content) }
            </QueueAnim>
          </div>

          <div className="article-float-footer">
            <Affix offsetBottom={10} >
              <div>
                <Button onClick={this.context.router.history.goBack}>
                  Back
                </Button>

                <Button>
                  <a href={p.url}>Original Link</a>
                </Button>
              </div>
            </Affix>
          </div>
        </article>
      // </ReactCSSTransitionGroup>
    );
  }
};


// WEBPACK FOOTER //
// ./src/components/Post.js